import axios from 'axios';
import { RecintoModel } from '../../pages/boletera/recintos/models/RecintoModel';

const API_URL = process.env.REACT_APP_API;

export async function obtenerRecintos() {
  const response = await axios.get(`${API_URL}recintos`);
  return response.data.doc.data;
}

export async function obtenerRecintoSelect(): Promise<Array<{ value: number; label: string; data: RecintoModel }>> {
  const response = await axios.get(`${API_URL}recintos`);
  const rows: RecintoModel[] = response.data?.doc?.data?.rows || [];
  return rows.map((r) => ({
    value: r.id,
    label: `${r.nombre} (aforo: ${r.aforo_max.toLocaleString()})`,
    data: r,
  }));
}

export async function crearRecintoService(recinto: Partial<RecintoModel>) {
  const { id, nombre, direccion, aforo_max } = recinto as any;
  const url = `${API_URL}recintos${id ? `/${id}` : ''}`;
  const payload = { nombre, direccion, aforo_max };
  const response = id
    ? await axios.patch(url, payload)
    : await axios.post(url, payload);
  return response;
}

export async function eliminarRecintoService(id: number) {
  return axios.delete(`${API_URL}recintos/${id}`);
}

export async function uploadMapaEvento(file: File) {
  const formData = new FormData();
  formData.append('mapa_ubicaciones', file);
  const response = await axios.post(`${API_URL}recintos/upload/mapa`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
}
